import Bynder from './Bynder';

export default Bynder;
